/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InventoryCountingRevisionDetInsertModel { 
    inventoryCountingId?: number;
    inventoryCountingNumber?: string | null;
    inventoryCountingName?: string | null;
    inventoryCountingDisplay?: string | null;
    ordinal?: number;
    itemNumber?: string | null;
    itemDescription?: string | null;
    uOfM?: string | null;
    countInventoryType?: number;
    readonly countInventoryTypeDisplay?: string | null;
    quantity?: number;
}

